import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _11c35fcb = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _a48af852 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _3c64a975 = () => interopDefault(import('../pages/business/index.vue' /* webpackChunkName: "pages/business/index" */))
const _9e312544 = () => interopDefault(import('../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _e1ac9d88 = () => interopDefault(import('../pages/employer-zone.vue' /* webpackChunkName: "pages/employer-zone" */))
const _909ae184 = () => interopDefault(import('../pages/employer/zone.vue' /* webpackChunkName: "pages/employer/zone" */))
const _f88cb852 = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _1ad6f25b = () => interopDefault(import('../pages/insta-hire/index.vue' /* webpackChunkName: "pages/insta-hire/index" */))
const _36b0ccf2 = () => interopDefault(import('../pages/pricing/index.vue' /* webpackChunkName: "pages/pricing/index" */))
const _081378c6 = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _a42efff4 = () => interopDefault(import('../pages/project-kvs-draft.vue' /* webpackChunkName: "pages/project-kvs-draft" */))
const _c2ff7462 = () => interopDefault(import('../pages/referral.vue' /* webpackChunkName: "pages/referral" */))
const _7bf032de = () => interopDefault(import('../pages/sep-faqs.vue' /* webpackChunkName: "pages/sep-faqs" */))
const _137859f3 = () => interopDefault(import('../pages/sign-in.vue' /* webpackChunkName: "pages/sign-in" */))
const _280eb069 = () => interopDefault(import('../pages/sign-up.vue' /* webpackChunkName: "pages/sign-up" */))
const _63c96b4d = () => interopDefault(import('../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _43b0bd13 = () => interopDefault(import('../pages/terms-condition.vue' /* webpackChunkName: "pages/terms-condition" */))
const _4d7a4be2 = () => interopDefault(import('../pages/training/index.vue' /* webpackChunkName: "pages/training/index" */))
const _09887f92 = () => interopDefault(import('../pages/covid-19/survey.vue' /* webpackChunkName: "pages/covid-19/survey" */))
const _ab76feee = () => interopDefault(import('../pages/employer/sign-up.vue' /* webpackChunkName: "pages/employer/sign-up" */))
const _317b3a90 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _6a005938 = () => interopDefault(import('../pages/job/post.vue' /* webpackChunkName: "pages/job/post" */))
const _7ebe4a37 = () => interopDefault(import('../pages/job/preview/index.vue' /* webpackChunkName: "pages/job/preview/index" */))
const _09bb46ef = () => interopDefault(import('../pages/job/search/index.vue' /* webpackChunkName: "pages/job/search/index" */))
const _748d8029 = () => interopDefault(import('../pages/jobseeker/data.vue' /* webpackChunkName: "pages/jobseeker/data" */))
const _13b17c5a = () => interopDefault(import('../pages/jobseeker/insights.vue' /* webpackChunkName: "pages/jobseeker/insights" */))
const _82e5c18a = () => interopDefault(import('../pages/jobseeker/registration/index.vue' /* webpackChunkName: "pages/jobseeker/registration/index" */))
const _383846aa = () => interopDefault(import('../pages/jobseeker/search/index.vue' /* webpackChunkName: "pages/jobseeker/search/index" */))
const _8c46aca0 = () => interopDefault(import('../pages/jobseeker/stats.vue' /* webpackChunkName: "pages/jobseeker/stats" */))
const _6452d3d2 = () => interopDefault(import('../pages/oauth2/callback.vue' /* webpackChunkName: "pages/oauth2/callback" */))
const _6aece814 = () => interopDefault(import('../pages/payment/cart-summary.vue' /* webpackChunkName: "pages/payment/cart-summary" */))
const _455e653f = () => interopDefault(import('../pages/payment/failure.vue' /* webpackChunkName: "pages/payment/failure" */))
const _7e498f38 = () => interopDefault(import('../pages/payment/success.vue' /* webpackChunkName: "pages/payment/success" */))
const _ec48ce44 = () => interopDefault(import('../pages/settings/change-password.vue' /* webpackChunkName: "pages/settings/change-password" */))
const _dbab12f0 = () => interopDefault(import('../pages/signup/basic-information.vue' /* webpackChunkName: "pages/signup/basic-information" */))
const _5570a7e0 = () => interopDefault(import('../pages/signup/employer.vue' /* webpackChunkName: "pages/signup/employer" */))
const _0f18eef3 = () => interopDefault(import('../pages/signup/employer-set-password.vue' /* webpackChunkName: "pages/signup/employer-set-password" */))
const _5a8d4fe4 = () => interopDefault(import('../pages/signup/employer-verify-otp.vue' /* webpackChunkName: "pages/signup/employer-verify-otp" */))
const _57b0a81d = () => interopDefault(import('../pages/signup/jobseeker.vue' /* webpackChunkName: "pages/signup/jobseeker" */))
const _31a8f2fd = () => interopDefault(import('../pages/signup/organization-details.vue' /* webpackChunkName: "pages/signup/organization-details" */))
const _690386e7 = () => interopDefault(import('../pages/signup/prefered-job-category.vue' /* webpackChunkName: "pages/signup/prefered-job-category" */))
const _62018ae4 = () => interopDefault(import('../pages/signup/prefered-location.vue' /* webpackChunkName: "pages/signup/prefered-location" */))
const _ded84838 = () => interopDefault(import('../pages/signup/profile.vue' /* webpackChunkName: "pages/signup/profile" */))
const _4daf7e0a = () => interopDefault(import('../pages/signup/set-password.vue' /* webpackChunkName: "pages/signup/set-password" */))
const _06d983ec = () => interopDefault(import('../pages/signup/verify-otp.vue' /* webpackChunkName: "pages/signup/verify-otp" */))
const _3b3e4823 = () => interopDefault(import('../pages/signup/working-status.vue' /* webpackChunkName: "pages/signup/working-status" */))
const _a2624bf2 = () => interopDefault(import('../pages/blog/category/_slug/index.vue' /* webpackChunkName: "pages/blog/category/_slug/index" */))
const _1c9a501a = () => interopDefault(import('../pages/blog/detail/_slug/index.vue' /* webpackChunkName: "pages/blog/detail/_slug/index" */))
const _35356add = () => interopDefault(import('../pages/blog/tag/_slug/index.vue' /* webpackChunkName: "pages/blog/tag/_slug/index" */))
const _03fd04a9 = () => interopDefault(import('../pages/business/category/_slug/index.vue' /* webpackChunkName: "pages/business/category/_slug/index" */))
const _b1928988 = () => interopDefault(import('../pages/business/detail/_slug/index.vue' /* webpackChunkName: "pages/business/detail/_slug/index" */))
const _68f611e4 = () => interopDefault(import('../pages/employer/detail/_id.vue' /* webpackChunkName: "pages/employer/detail/_id" */))
const _cfaf2e9c = () => interopDefault(import('../pages/employer/profile/_id.vue' /* webpackChunkName: "pages/employer/profile/_id" */))
const _76abba07 = () => interopDefault(import('../pages/faq/category/_slug/index.vue' /* webpackChunkName: "pages/faq/category/_slug/index" */))
const _13a19fcc = () => interopDefault(import('../pages/faq/detail/_slug/index.vue' /* webpackChunkName: "pages/faq/detail/_slug/index" */))
const _61e9e6bc = () => interopDefault(import('../pages/faq/tags/_slug/index.vue' /* webpackChunkName: "pages/faq/tags/_slug/index" */))
const _baf77fb6 = () => interopDefault(import('../pages/jobseeker/profile/_id.vue' /* webpackChunkName: "pages/jobseeker/profile/_id" */))
const _def693d4 = () => interopDefault(import('../pages/referrer/profile/_id.vue' /* webpackChunkName: "pages/referrer/profile/_id" */))
const _207cfd2c = () => interopDefault(import('../pages/errors/_statusCode.vue' /* webpackChunkName: "pages/errors/_statusCode" */))
const _50e78e72 = () => interopDefault(import('../pages/training/_slug.vue' /* webpackChunkName: "pages/training/_slug" */))
const _f215b3d6 = () => interopDefault(import('../pages/job/_jobSlug/applications.vue' /* webpackChunkName: "pages/job/_jobSlug/applications" */))
const _6052847a = () => interopDefault(import('../pages/job/_jobSlug/detail.vue' /* webpackChunkName: "pages/job/_jobSlug/detail" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _11c35fcb,
    name: "about___ne"
  }, {
    path: "/blog",
    component: _a48af852,
    name: "blog___ne"
  }, {
    path: "/business",
    component: _3c64a975,
    name: "business___ne"
  }, {
    path: "/contact",
    component: _9e312544,
    name: "contact___ne"
  }, {
    path: "/employer-zone",
    component: _e1ac9d88,
    children: [{
      path: "",
      component: _909ae184,
      name: "employer-zone___ne"
    }]
  }, {
    path: "/faq",
    component: _f88cb852,
    name: "faq___ne"
  }, {
    path: "/insta-hire",
    component: _1ad6f25b,
    name: "insta-hire___ne"
  }, {
    path: "/pricing",
    component: _36b0ccf2,
    name: "pricing___ne"
  }, {
    path: "/privacy",
    component: _081378c6,
    name: "privacy___ne"
  }, {
    path: "/project-kvs-draft",
    component: _a42efff4,
    name: "project-kvs-draft___ne"
  }, {
    path: "/referral",
    component: _c2ff7462,
    name: "referral___ne"
  }, {
    path: "/sep-faqs",
    component: _7bf032de,
    name: "sep-faqs___ne"
  }, {
    path: "/sign-in",
    component: _137859f3,
    name: "sign-in___ne"
  }, {
    path: "/sign-up",
    component: _280eb069,
    name: "sign-up___ne"
  }, {
    path: "/signup",
    component: _63c96b4d,
    name: "signup___ne"
  }, {
    path: "/terms-condition",
    component: _43b0bd13,
    name: "terms-condition___ne"
  }, {
    path: "/training",
    component: _4d7a4be2,
    name: "training___ne"
  }, {
    path: "/covid-19/survey",
    component: _09887f92,
    name: "covid-19-survey___ne"
  }, {
    path: "/employer/sign-up",
    component: _ab76feee,
    name: "employer-sign-up___ne"
  }, {
    path: "/en/",
    component: _317b3a90,
    name: "index___en"
  }, {
    path: "/en/about",
    component: _11c35fcb,
    name: "about___en"
  }, {
    path: "/en/blog",
    component: _a48af852,
    name: "blog___en"
  }, {
    path: "/en/business",
    component: _3c64a975,
    name: "business___en"
  }, {
    path: "/en/contact",
    component: _9e312544,
    name: "contact___en"
  }, {
    path: "/en/employer-zone",
    component: _e1ac9d88,
    children: [{
      path: "",
      component: _909ae184,
      name: "employer-zone___en"
    }]
  }, {
    path: "/en/faq",
    component: _f88cb852,
    name: "faq___en"
  }, {
    path: "/en/insta-hire",
    component: _1ad6f25b,
    name: "insta-hire___en"
  }, {
    path: "/en/pricing",
    component: _36b0ccf2,
    name: "pricing___en"
  }, {
    path: "/en/privacy",
    component: _081378c6,
    name: "privacy___en"
  }, {
    path: "/en/project-kvs-draft",
    component: _a42efff4,
    name: "project-kvs-draft___en"
  }, {
    path: "/en/referral",
    component: _c2ff7462,
    name: "referral___en"
  }, {
    path: "/en/sep-faqs",
    component: _7bf032de,
    name: "sep-faqs___en"
  }, {
    path: "/en/sign-in",
    component: _137859f3,
    name: "sign-in___en"
  }, {
    path: "/en/sign-up",
    component: _280eb069,
    name: "sign-up___en"
  }, {
    path: "/en/signup",
    component: _63c96b4d,
    name: "signup___en"
  }, {
    path: "/en/terms-condition",
    component: _43b0bd13,
    name: "terms-condition___en"
  }, {
    path: "/en/training",
    component: _4d7a4be2,
    name: "training___en"
  }, {
    path: "/job/post",
    component: _6a005938,
    name: "job-post___ne"
  }, {
    path: "/job/preview",
    component: _7ebe4a37,
    name: "job-preview___ne"
  }, {
    path: "/job/search",
    component: _09bb46ef,
    name: "job-search___ne"
  }, {
    path: "/jobseeker/data",
    component: _748d8029,
    name: "jobseeker-data___ne"
  }, {
    path: "/jobseeker/insights",
    component: _13b17c5a,
    name: "jobseeker-insights___ne"
  }, {
    path: "/jobseeker/registration",
    component: _82e5c18a,
    name: "jobseeker-registration___ne"
  }, {
    path: "/jobseeker/search",
    component: _383846aa,
    name: "jobseeker-search___ne"
  }, {
    path: "/jobseeker/stats",
    component: _8c46aca0,
    name: "jobseeker-stats___ne"
  }, {
    path: "/oauth2/callback",
    component: _6452d3d2,
    name: "oauth2-callback___ne"
  }, {
    path: "/payment/cart-summary",
    component: _6aece814,
    name: "payment-cart-summary___ne"
  }, {
    path: "/payment/failure",
    component: _455e653f,
    name: "payment-failure___ne"
  }, {
    path: "/payment/success",
    component: _7e498f38,
    name: "payment-success___ne"
  }, {
    path: "/settings/change-password",
    component: _ec48ce44,
    name: "settings-change-password___ne"
  }, {
    path: "/signup/basic-information",
    component: _dbab12f0,
    name: "signup-basic-information___ne"
  }, {
    path: "/signup/employer",
    component: _5570a7e0,
    name: "signup-employer___ne"
  }, {
    path: "/signup/employer-set-password",
    component: _0f18eef3,
    name: "signup-employer-set-password___ne"
  }, {
    path: "/signup/employer-verify-otp",
    component: _5a8d4fe4,
    name: "signup-employer-verify-otp___ne"
  }, {
    path: "/signup/jobseeker",
    component: _57b0a81d,
    name: "signup-jobseeker___ne"
  }, {
    path: "/signup/organization-details",
    component: _31a8f2fd,
    name: "signup-organization-details___ne"
  }, {
    path: "/signup/prefered-job-category",
    component: _690386e7,
    name: "signup-prefered-job-category___ne"
  }, {
    path: "/signup/prefered-location",
    component: _62018ae4,
    name: "signup-prefered-location___ne"
  }, {
    path: "/signup/profile",
    component: _ded84838,
    name: "signup-profile___ne"
  }, {
    path: "/signup/set-password",
    component: _4daf7e0a,
    name: "signup-set-password___ne"
  }, {
    path: "/signup/verify-otp",
    component: _06d983ec,
    name: "signup-verify-otp___ne"
  }, {
    path: "/signup/working-status",
    component: _3b3e4823,
    name: "signup-working-status___ne"
  }, {
    path: "/en/covid-19/survey",
    component: _09887f92,
    name: "covid-19-survey___en"
  }, {
    path: "/en/employer/sign-up",
    component: _ab76feee,
    name: "employer-sign-up___en"
  }, {
    path: "/en/job/post",
    component: _6a005938,
    name: "job-post___en"
  }, {
    path: "/en/job/preview",
    component: _7ebe4a37,
    name: "job-preview___en"
  }, {
    path: "/en/job/search",
    component: _09bb46ef,
    name: "job-search___en"
  }, {
    path: "/en/jobseeker/data",
    component: _748d8029,
    name: "jobseeker-data___en"
  }, {
    path: "/en/jobseeker/insights",
    component: _13b17c5a,
    name: "jobseeker-insights___en"
  }, {
    path: "/en/jobseeker/registration",
    component: _82e5c18a,
    name: "jobseeker-registration___en"
  }, {
    path: "/en/jobseeker/search",
    component: _383846aa,
    name: "jobseeker-search___en"
  }, {
    path: "/en/jobseeker/stats",
    component: _8c46aca0,
    name: "jobseeker-stats___en"
  }, {
    path: "/en/oauth2/callback",
    component: _6452d3d2,
    name: "oauth2-callback___en"
  }, {
    path: "/en/payment/cart-summary",
    component: _6aece814,
    name: "payment-cart-summary___en"
  }, {
    path: "/en/payment/failure",
    component: _455e653f,
    name: "payment-failure___en"
  }, {
    path: "/en/payment/success",
    component: _7e498f38,
    name: "payment-success___en"
  }, {
    path: "/en/settings/change-password",
    component: _ec48ce44,
    name: "settings-change-password___en"
  }, {
    path: "/en/signup/basic-information",
    component: _dbab12f0,
    name: "signup-basic-information___en"
  }, {
    path: "/en/signup/employer",
    component: _5570a7e0,
    name: "signup-employer___en"
  }, {
    path: "/en/signup/employer-set-password",
    component: _0f18eef3,
    name: "signup-employer-set-password___en"
  }, {
    path: "/en/signup/employer-verify-otp",
    component: _5a8d4fe4,
    name: "signup-employer-verify-otp___en"
  }, {
    path: "/en/signup/jobseeker",
    component: _57b0a81d,
    name: "signup-jobseeker___en"
  }, {
    path: "/en/signup/organization-details",
    component: _31a8f2fd,
    name: "signup-organization-details___en"
  }, {
    path: "/en/signup/prefered-job-category",
    component: _690386e7,
    name: "signup-prefered-job-category___en"
  }, {
    path: "/en/signup/prefered-location",
    component: _62018ae4,
    name: "signup-prefered-location___en"
  }, {
    path: "/en/signup/profile",
    component: _ded84838,
    name: "signup-profile___en"
  }, {
    path: "/en/signup/set-password",
    component: _4daf7e0a,
    name: "signup-set-password___en"
  }, {
    path: "/en/signup/verify-otp",
    component: _06d983ec,
    name: "signup-verify-otp___en"
  }, {
    path: "/en/signup/working-status",
    component: _3b3e4823,
    name: "signup-working-status___en"
  }, {
    path: "/en/blog/category/:slug?",
    component: _a2624bf2,
    name: "blog-category-slug___en"
  }, {
    path: "/en/blog/detail/:slug?",
    component: _1c9a501a,
    name: "blog-detail-slug___en"
  }, {
    path: "/en/blog/tag/:slug?",
    component: _35356add,
    name: "blog-tag-slug___en"
  }, {
    path: "/en/business/category/:slug?",
    component: _03fd04a9,
    name: "business-category-slug___en"
  }, {
    path: "/en/business/detail/:slug?",
    component: _b1928988,
    name: "business-detail-slug___en"
  }, {
    path: "/en/employer/detail/:id?",
    component: _68f611e4,
    name: "employer-detail-id___en"
  }, {
    path: "/en/employer/profile/:id?",
    component: _cfaf2e9c,
    name: "employer-profile-id___en"
  }, {
    path: "/en/faq/category/:slug?",
    component: _76abba07,
    name: "faq-category-slug___en"
  }, {
    path: "/en/faq/detail/:slug?",
    component: _13a19fcc,
    name: "faq-detail-slug___en"
  }, {
    path: "/en/faq/tags/:slug?",
    component: _61e9e6bc,
    name: "faq-tags-slug___en"
  }, {
    path: "/en/jobseeker/profile/:id?",
    component: _baf77fb6,
    name: "jobseeker-profile-id___en"
  }, {
    path: "/en/referrer/profile/:id?",
    component: _def693d4,
    name: "referrer-profile-id___en"
  }, {
    path: "/blog/category/:slug?",
    component: _a2624bf2,
    name: "blog-category-slug___ne"
  }, {
    path: "/blog/detail/:slug?",
    component: _1c9a501a,
    name: "blog-detail-slug___ne"
  }, {
    path: "/blog/tag/:slug?",
    component: _35356add,
    name: "blog-tag-slug___ne"
  }, {
    path: "/business/category/:slug?",
    component: _03fd04a9,
    name: "business-category-slug___ne"
  }, {
    path: "/business/detail/:slug?",
    component: _b1928988,
    name: "business-detail-slug___ne"
  }, {
    path: "/employer/detail/:id?",
    component: _68f611e4,
    name: "employer-detail-id___ne"
  }, {
    path: "/employer/profile/:id?",
    component: _cfaf2e9c,
    name: "employer-profile-id___ne"
  }, {
    path: "/en/errors/:statusCode?",
    component: _207cfd2c,
    name: "errors-statusCode___en"
  }, {
    path: "/en/training/:slug",
    component: _50e78e72,
    name: "training-slug___en"
  }, {
    path: "/faq/category/:slug?",
    component: _76abba07,
    name: "faq-category-slug___ne"
  }, {
    path: "/faq/detail/:slug?",
    component: _13a19fcc,
    name: "faq-detail-slug___ne"
  }, {
    path: "/faq/tags/:slug?",
    component: _61e9e6bc,
    name: "faq-tags-slug___ne"
  }, {
    path: "/jobseeker/profile/:id?",
    component: _baf77fb6,
    name: "jobseeker-profile-id___ne"
  }, {
    path: "/referrer/profile/:id?",
    component: _def693d4,
    name: "referrer-profile-id___ne"
  }, {
    path: "/en/job/:jobSlug?/applications",
    component: _f215b3d6,
    name: "job-jobSlug-applications___en"
  }, {
    path: "/en/job/:jobSlug?/detail",
    component: _6052847a,
    name: "job-jobSlug-detail___en"
  }, {
    path: "/errors/:statusCode?",
    component: _207cfd2c,
    name: "errors-statusCode___ne"
  }, {
    path: "/training/:slug",
    component: _50e78e72,
    name: "training-slug___ne"
  }, {
    path: "/job/:jobSlug?/applications",
    component: _f215b3d6,
    name: "job-jobSlug-applications___ne"
  }, {
    path: "/job/:jobSlug?/detail",
    component: _6052847a,
    name: "job-jobSlug-detail___ne"
  }, {
    path: "/",
    component: _317b3a90,
    name: "index___ne"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
